import React from "react";

import {
  Box,
  Button,
  ButtonGroup,
  Dialog,
  IconButton,
  FormControl,
  MenuItem,
  Select,
  InputBase,
} from "@mui/material";

import CloseIcon from "@mui/icons-material/Close";

import "./../../style/Home.css";

import { LocalizationProvider, DatePicker } from "@mui/x-date-pickers";
import dayjs from "dayjs";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import ArrowDropDownCircleOutlinedIcon from "@mui/icons-material/ArrowDropDownCircleOutlined";
import { styled } from "@mui/material/styles";

class TimeframeSelect extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      timeframe: "CurrentMonth",
      today: dayjs(),
      modalOpen: false,
      start: dayjs(),
      end: dayjs(),
    };
  }

  StyledSelect = styled(InputBase)(({ theme }) => ({
    "& .MuiInputBase-input": {
      "&:focus": {
        backgroundColor: "transparent",
      },
    },
  }));

  StyledDialog = styled(Dialog)(({ theme }) => ({
    "& .MuiDialog-paper": {
      maxWidth: "716px",
    },
  }));

  handleClose = () => {
    this.setState({ modalOpen: false });
  };

  handleOpen = (timeframe) => {
    this.setState({ modalOpen: true, timeframe: timeframe });
  };

  handleCustomDate = (which, date) => {
    this.setState({ [which]: date });
  };

  handleClick = (timeframe, start, end) => {
    console.log("timeframe: ", timeframe);
    this.setState({
      timeframe: timeframe,
      modalOpen: false,
    });
    this.props.setTimeframe(timeframe, start, end);
  };

  render() {
    return (
      <div className="col-12 mr-1 ml-0 mt-0">
        <Box
          display="flex"
          flexDirection="row"
          justifyContent="center"
          alignSelf="center"
          style={{ width: "100%" }}
        >
          <FormControl
            size="small"
            style={{
              width: "180px",
              border: 0,
              color: "#3E3E3E",
            }}
          >
            <Select
              className="timeframeSelect"
              disableUnderline={true}
              value={this.state.selectedGroup}
              input={<this.StyledSelect label={"groups"} />}
              IconComponent={(props) => (
                <ArrowDropDownCircleOutlinedIcon
                  {...props}
                  sx={{
                    color: "#0073a8",
                    fill: "#0073a8",
                  }}
                />
              )}
              onChange={(value) =>
                value.target.value === "CustomDateRange"
                  ? this.handleOpen("CustomDateRange")
                  : this.handleClick(value.target.value, "", "")
              }
              label="groups"
              defaultValue="CurrentMonth"
              style={{ color: "#404040", width: "100%", fontSize: "15px" }}
            >
              <MenuItem value={"CurrentMonth"}>Last 30 Days</MenuItem>
              <MenuItem value={"LastMonth"}>Last Month</MenuItem>
              <MenuItem value={"CurrentYear"}>Current Year</MenuItem>
              <MenuItem value={"LastYear"}>Last Year</MenuItem>
              <MenuItem value={"CustomDateRange"}>Custom</MenuItem>
            </Select>
          </FormControl>
        </Box>
        <this.StyledDialog
          disableBackdropClick
          style={{
            display: "flex",
            alignSelf: "center",
            justifyContent: "center",
          }}
          open={this.state.modalOpen}
          onClose={this.handleClose}
        >
          <Box
            display="flex"
            flexDirection="column"
            style={{
              backgroundColor: "#ffffff",
              width: "716px",
              padding: "40px",
            }}
          >
            <span style={{ fontSize: "27px", color: '#404040' }}>Enter a Custom Date Range</span>
            <Box display="flex" flexDirection="column" alignItems="center">
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                  marginTop: "48px",
                  width: "100%",
                }}
              >
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DatePicker
                    sx={{ width: "296px" }}
                    slotProps={{ textField: { size: "small" } }}
                    disableToolbar
                    variant="inline"
                    id="date-picker-start"
                    maxDate={this.state.today}
                    label="From"
                    value={this.state.start}
                    autoOk={true}
                    onChange={(start) => this.handleCustomDate("start", start)}
                    KeyboardButtonProps={{
                      "aria-label": "change start date",
                    }}
                  />
                </LocalizationProvider>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DatePicker
                    sx={{ width: "296px" }}
                    slotProps={{ textField: { size: "small" } }}
                    disableToolbar
                    variant="inline"
                    id="date-picker-end"
                    maxDate={this.state.today}
                    label="To"
                    value={this.state.end}
                    autoOk={true}
                    onChange={(end) => this.handleCustomDate("end", end)}
                    KeyboardButtonProps={{
                      "aria-label": "change end date",
                    }}
                  />
                </LocalizationProvider>
              </div>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                  width: "100%",
                  marginTop: "32px",
                }}
              >
                <Button
                  onClick={() =>
                    this.handleClick(
                      "CustomDateRange",
                      this.state.start,
                      this.state.end
                    )
                  }
                  //sx={{ px: 8 }}
                  style={{
                    backgroundColor: "#0073a8",
                    color: "#fff",
                    width: "296px",
                    fontWeight: "bold",
                    fontSize: "15px",
                  }}
                >
                  Set Range
                </Button>
                <Button
                  // sx={{ px: 8 }}
                  onClick={this.handleClose}
                  style={{
                    backgroundColor: "#fff",
                    color: "#0073a8",
                    border: "#0073a8 solid 1px",
                    width: "296px",
                    fontWeight: "bold",
                    fontSize: "15px",
                  }}
                >
                  Cancel
                </Button>
              </div>
            </Box>
          </Box>
        </this.StyledDialog>
      </div>
    );
  }
}

export default TimeframeSelect;
